import { render, staticRenderFns } from "./LkCart.vue?vue&type=template&id=2d568a43&scoped=true&"
import script from "./LkCart.vue?vue&type=script&lang=js&"
export * from "./LkCart.vue?vue&type=script&lang=js&"
import style0 from "./LkCart.vue?vue&type=style&index=0&id=2d568a43&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d568a43",
  null
  
)

export default component.exports